import React from "react";

const Loader: React.FC = () => {
  return <></>;
};

export default Loader;
